/**
 * Generated runtime TestId mirror for frontend/src/components/form-layout/designer/PreviewPane.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PreviewPaneTestIds = {
  exitPreviewBtn: "exit-preview-btn",
  previewSectionTitle: (section_key: string) => `preview-section-title-${section_key}`,
  previewSectionTitlePrefix: () => "preview-section-title-" as TestIdPrefix
} as const;
